import Heading, { HeadingType } from "../atoms/Heading";

export type CentreCtaSectionPropType = {
  title: string;
  title2:string;
  results:HeadingType;
  gradient?: boolean;
  maxWidth?: "max-w-[400px]" | "max-w-[720px]";
};

type DescriptionType = {
  text: string;
  href?: string;
}[];

const ResultsSection = ({
  title,
  results,
  title2,
  gradient = false,
  maxWidth = "max-w-[400px]",
}: CentreCtaSectionPropType) => {

  return (
    <div
      className={`relative w-full overflow-hidden ${
        gradient ? "bg-aurora1" : "bg-purple-0"
      } py-6 sm:py-12`}
    >
      <div className="container flex flex-col gap-10">
        <div className="flex flex-col items-center justify-center gap-8">
          <p className={`text-center text-body-24 text-grey-4`}>
            {/* {renderDescription()} */}
            {title}
          </p>
          <Heading
            heading={results}
            fontStyle="text-title-20 sm:text-title-32"
            as="h6"
          />
          <p className={`${maxWidth} text-center text-body-24 text-grey-4`}>
            {/* {renderDescription()} */}
            {title2}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResultsSection;
